import Vue from 'vue';

// When the request succeeds
const success = (response, context) => {
    context.loading = false;
    context.paymentDisabled = false;

    if (response.data.msg === 'requires_source_action') {
        context.paymentIntent = response.data.intent;
        $("#secure-iframe").attr("src", context.paymentIntent.next_action.redirect_to_url.url);
        $("#secure-iframe").css("display", "block");
        context.showSecureIframe = true;
      } else {
        context.paymentIntent = null;
        Vue.router.push({
          name: 'payment.success',
          params: { permalink: context.$route.params.permalink , status: 'success' }
        });
      }
};

// When the request fails
const failed = (error, context) => {
    context.loading = false;
    context.paymentDisabled = false;
    context.showSecureIframe = false;
    if(error && error.response && error.response.data && error.response.data.reason) {
      toastr.error(context.$t('payments.error.card_declined'));
      context.error = context.$t('payments.error.card_declined');
    } else {
      context.error = error;
      context.showToasterError(error);
    }
};

export default (data, context) => {
    return Vue.$http.post('payments/checkout', data).then((response) => {
        if (response.status === 200) {
            success(response, context);
        } else {
            failed();
        }
    }).catch((error) => {
        failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/payment/checkout.js